import { useTranslation } from "@opendash/i18n";
import { ScheduleDataObjectType } from "@opendash/schedule";
import { Button, Modal, Spin, Tag, Tooltip } from "antd";
import { Dayjs } from "dayjs";
import { observer } from "mobx-react-lite";
import * as React from "react";
import { useEffect, useState } from "react";
import { CronEditor } from "..";

/**
 * React component to create a cron form
 * You have to wrap it in antd <Form> component
 *
 * @param value - ValueChangeType
 * @param setValue - Function which returns the value of type ValueChangeType
 *
 * @author Nico Vitt
 */
export const CronForm = observer(
  (props: {
    value: ScheduleDataObjectType;
    setValue: (value: ScheduleDataObjectType) => void;
  }) => {
    const t = useTranslation();
    const [loading, setLoading] = useState<boolean>(true);
    const [modalOpen, setModalOpen] = useState<boolean>(false);

    useEffect(() => {
      setLoading(false);
    }, [props.value]);

    function handleSubmit(values: ScheduleDataObjectType<Dayjs>) {
      const valuesToSave: ScheduleDataObjectType<Date> = {
        ...values,
        timestamp: {
          ...values.timestamp,
          startDate: values.timestamp.startDate?.toDate(),
          endDate: values.timestamp.endDate?.toDate(),
        },
      };

      props.setValue(valuesToSave);
      setModalOpen(false);
    }

    if (loading) {
      return <Spin />;
    }

    //If props.setValue is undefined the component is only for display
    if (!props.setValue) {
      return (
        <Tooltip title={JSON.stringify(props.value)}>
          <Tag>
            {props.value?.timestamp?.number}{" "}
            {t("opendash:timestamp." + props.value?.timestamp?.unit)}
          </Tag>
        </Tooltip>
      );
    } else {
      //If props.setValue is a function and not undefined, return CronEditor
      return (
        <>
          <Modal
            title={t("opendash:cron.edit.title")}
            open={modalOpen}
            onCancel={() => setModalOpen(false)}
            footer={null}
          >
            <CronEditor initialValues={props.value} onSubmit={handleSubmit} />
          </Modal>
          <Button onClick={() => setModalOpen(true)}>
            {t("opendash:cron.edit.title")}
          </Button>
        </>
      );
    }
  }
);
